<template>
  <div class="categories-mobile-main w-100">
  <v-row no-gutters class="d-lg-none text-xsmall bg-white heading-filter">
    <v-col class="px-1 pt-1 text-black">
      <b>{{ name == 'feed' ? 'Categorias': 'Ofertas' }}</b>
    </v-col>
    <v-col class="px-1 pt-1 text-right text-color-0">
      <v-menu>
        <template v-slot:activator="{ props }">
          <a v-bind="props" class="cursor-pointer">
            Ordenar
          </a>
        </template>
        <v-list>
          <v-list-item @click="order = 0">A-Z</v-list-item>
          <v-list-item @click="order = 1">Z-A</v-list-item>
          <v-list-item @click="order = 2">Maior preço</v-list-item>
          <v-list-item @click="order = 3">Menor preço</v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
  <v-skeleton-loader :loading="loadingTabs" type="avatar, avatar, avatar" class="d-lg-none pt-4">
    <v-row class="pa-2 ma-0 categories-mobile bg-white text-xxsmall text-color-0 cursor-pointer d-flex d-lg-none">
      <a v-for="t in getTabs" v-bind:key="t.id" @click="$router.push('/'+tabName(t.type)+'/'+t.id)" class="d-flex justify-center flex-wrap">
        <div :class="tab != null && tab.id == t.id && t.type == tab.type ? 'img-active': ''">
          <Svgs v-if="t.name == 'OFERTAS'" :icon="'ofertason'" :color="tab != null && tab.id == t.id && t.type == tab.type ? 'fill-color-2': 'fill-color-0'" :width="60" :height="60"></Svgs>
          <img v-else-if="t.image != undefined && t.image != '' && t.image != null && t.image != 'no-image'" :src="t.image" alt="Produto">
          <img v-else-if="t.image == 'no-image'" src="@/assets/images/genericproduct.jpg" alt="Produto">
        </div>
        <span :class="tab != null && tab.id == t.id && t.type == tab.type ? 'text-color-2 text-bold': ''">{{ capitalize(t.name) }}</span>
      </a>
    </v-row>
  </v-skeleton-loader>
  <v-row class="pa-2 ma-0 subcategories-mobile bg-color-gray text-color-0 cursor-pointer d-lg-none" v-if="name == 'feed'">
    <v-skeleton-loader :loading="loadingSubCategories" type="text" width="100%" class="bg-color-gray pa-0 ma-0">
      <v-col class="w-100 text-xxsmall d-flex flex-nowrap pa-0 ma-0" v-if="tab != null && tab.subcategories != undefined && tab.subcategories.length > 0">
        <a v-for="ts in tab.subcategories" v-bind:key="ts.id_subcategoria" @click="$router.push('/'+tabName(tab.type)+'/'+tab.id+'/'+ts.id_subcategoria)" class="d-flex justify-center text-nowrap mr-3">
          <span :class="subcategories == ts.id_subcategoria ? 'text-color-2 text-bold': ''">{{ capitalize(ts.nome_subcategoria) }} ({{ ts.count }})</span>
        </a>
      </v-col>
    </v-skeleton-loader>
  </v-row>
  </div>
  <div v-if="getTabs != null && getTabs.length > 0 &&id_tab == getTabs[0].id" class="d-lg-none mt-3">
    <CarouselBanner :banners="getCarouselBanners"></CarouselBanner>
  </div>
  <v-container class="px-0 my-0 pt-0 my-lg-3">
    <v-row class="mt-0 mt-lg-3">
      <v-col class="v-col-12 v-col-lg-3 d-none d-lg-block pt-0 pt-lg-2" v-if="layout == 1">
        <div class="w-100 bg-white">
          <v-list class="pa-0 w-100 br-top-5" v-if="tab != null && tab.subcategories != undefined">
            <v-list-item prepend-icon="mdi-filter-variant" class="bg-color-2 text-white">Filtros por Setor</v-list-item>
          </v-list>
          <v-skeleton-loader :loading="loadingSubCategories" type="list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item">
            <v-list class="pa-0 w-100" v-if="tab != null">
              <v-list-item v-for="ts in tab.subcategories" v-bind:key="ts.id_subcategoria"> 
                <template v-slot:prepend>
                  <v-checkbox :id="'cat_'+ts.id_subcategoria" v-model="subcategories" :value="''+ts.id_subcategoria" :hide-details="true" density="compact" :color="'var(--color-one)'" class="text-color-0"></v-checkbox>
                </template>
                <div class="px-2 text-color-0">
                  <label class="cursor-pointer" :for="'cat_'+ts.id_subcategoria">{{ capitalize(ts.nome_subcategoria) }}</label>
                </div>
                <template v-slot:append>
                  <small class="text-color-1">({{ ts.count }})</small>
                </template>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <!-- <v-list class="pa-0 w-100 br-0">
            <v-list-item prepend-icon="mdi-filter-variant" class="bg-color-2 text-white">Filtros por Preço</v-list-item>
          </v-list>
          <div class="pa-4">
            <v-range-slider v-model="filter_price" strict min="0" max="1000" step="1" :thumb-label="true" hide-details track-color="var(--color-gray)" track-fill-color="var(--color-one)" thumb-color="white" @end="filterPrice()"></v-range-slider>
          </div> -->
        </div>
      </v-col>
      <v-col class="v-col-12 px-5 px-lg-0 pt-0 pt-lg-2" :class="layout == 1 ? 'v-col-lg-9': 'v-col-lg-12'">
        <div class="w-100 bg-lg-white pa-2 pa-lg-5 br-top-5">
          <v-skeleton-loader :loading="tab == null" type="heading" width="200px" height="23px" class="ma-0 d-none d-lg-block">
            <v-breadcrumbs class="pa-0">
              <v-breadcrumbs-item class="text-color-0">Home</v-breadcrumbs-item>
              <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
              <v-breadcrumbs-item class="text-color-0" v-if="tab != null">{{ tab.name }}</v-breadcrumbs-item>
              <v-skeleton-loader v-else type="text"></v-skeleton-loader>
            </v-breadcrumbs>
          </v-skeleton-loader>
          <v-row class="mt-0 mt-lg-3 d-none d-lg-flex">
            <v-col cols="12" class="d-flex py-0" v-if="layout == 1">
              <v-skeleton-loader :loading="loadingSubCategories" type="heading" width="400px" height="35px" class="ma-0">
                <b class="text-color-black text-xlarge me-3" v-if="isLoading == false && subcategories.length == 0">
                  Todos
                </b>
                <b class="text-color-black text-xlarge" v-for="(s, index) in subcategories" v-bind:key="index" v-else>
                  <span>{{ capitalize(getSubCategoryById(tab.id, s)) }}</span><span v-if="index < subcategories.length - 2">,&nbsp;</span><span v-if="index == subcategories.length - 2">&nbsp;&&nbsp;</span>
                </b>
              </v-skeleton-loader>
            </v-col>
            <v-col class="d-flex">
              <v-skeleton-loader :loading="loadingProducts" type="text" width="120px" class="ma-0">
                <b class="text-color-0">{{ getCount }} {{ getCount == 1 ? 'produto':'produtos'}}</b>
              </v-skeleton-loader>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn flat variant="text" @click="order = 0" class="br-10" :class="order == 0 ? 'text-color-1': 'text-color-0'">
                A-Z
              </v-btn>
              <v-btn flat variant="text" @click="order = 1" class="br-10 ms-1" :class="order == 1 ? 'text-color-1': 'text-color-0'">
                Z-A
              </v-btn>
              <v-btn flat variant="text" @click="order = 2" class="br-10 ms-1" :class="order == 2 ? 'text-color-1': 'text-color-0'">
                Maior preço
              </v-btn>
              <v-btn flat variant="text" @click="order = 3" class="br-10 ms-1" :class="order == 3 ? 'text-color-1': 'text-color-0'">
                Menor preço
              </v-btn>
            </v-col>
          </v-row>
          <div v-if="loadingProducts">
            <v-row class="mt-0 mt-lg-3">
              <v-col v-for="a in 6" :key="a" class="v-col-12 pa-0 pa-lg-7 v-col-xl-3 d-flex justify-center" :class="layout == 1 ? 'v-col-lg-4': 'v-col-lg-3'">
                <v-skeleton-loader type="image" width="100%" height="400px" class="d-none d-lg-block"></v-skeleton-loader>
                <v-skeleton-loader type="image, image" width="100%" height="200px" class="d-block d-lg-none with-margin"></v-skeleton-loader>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-row v-if="paginacao > 0 && getProdutosFeed.length > 0" class="mt-0 mt-lg-3">
              <v-col v-for="p in getProdutosFeed" :key="p.isu" class="v-col-12 pa-0 pa-lg-2 d-flex justify-center" :class="layout == 1 ? 'v-col-lg-4 v-col-xl-3': 'v-col-lg-3 v-col-xl-2'">
                <Product :product="p"></Product>
              </v-col>
              <v-col v-if="isLoading" class="v-col-12 d-flex justify-center">
                <v-progress-circular color="primary" indeterminate></v-progress-circular>
              </v-col>
            </v-row>
            <v-row v-else-if="paginacao > 0" class="my-6">
              <v-col class="v-col-12 pa-0 pa-lg-2 d-flex justify-center">
              <span class="text-color-1">Nenhum produto encontrado.</span>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Product from '@/components/Product.vue';
import { capitalize } from '@/store/services/utils.js';
import CarouselBanner from '@/components/CarouselBanner.vue';
import Svgs from '@/components/Svgs.vue'
export default {
  name: "Feed",
  components: {
    Product,
    CarouselBanner,
    Svgs
  },
  data(){
    return {
      name: '',
      id_tab: null,
      tab: null,
      isLoading: true,
      loadingProdutos: true,
      paginacao: 0,
      subcategories: [],
      order: 0,
      layout: 1,
      filter_price: [0, 1000]
    }
  },
  computed: {
    ...mapGetters('products', {
      getProdutosFeed: 'getProdutosFeed',
      getCount: 'getCount'
    }),
    ...mapGetters('main', {
      getTabById: 'getTabById',
      getTabs: 'getTabs',
      getCarouselBanners: 'getCarouselBanners',
      getSubCategoryById: 'getSubCategoryById'
    }),
    ...mapState('main', {
      loadingTabs: 'loadingTabs',
      loadingSubCategories: 'loadingSubCategories'
    }),
    ...mapState('products', {
      loadingProducts: 'loadingProducts'
    }),
  },
  watch: {
    "subcategories"(subcategories, old) {
      console.log(subcategories);
      console.log(old);
      if((subcategories != undefined && subcategories.length > 0) || (subcategories.length == 0 && old.length > 0)){
        console.log("Entrou");
        this.selectSubcat();
      }
    },
    "order"(){
      this.Nav();
    }
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig',
      getSubCategories: 'getSubCategories',
      getBanners: 'getBanners'
    }),
    ...mapActions('products', {
      getProdutos: 'getProdutos'
    }),
    capitalize,
    tabName(type){
      var name = null;
      switch(type){
        case 0: name = "cluster"; break;
        case 1: name = "offers"; break;
        case 2: name = "campaign"; break;
        case 3: name = "feed"; break;
      }
      return name;
    },
    tabConvert(){
      var type = null;
      switch(this.name){
        case "cluster": type = 0; break;
        case "offers": type = 1; break;
        case "campaign": type = 2; break;
        case "feed": type = 3; break;
      }
      return type;
    },
    Nav(){
      this.id_tab = this.$route['params']['id'];
      this.tab = this.getTabById(this.tabConvert(), this.id_tab);
      this.paginacao = 0;
      if(this.name == 'feed'){
        this.layout = 1;
        var subcategories = this.$route['params']['subcategories'];
        if(subcategories != undefined){
          if(this.subcategories != subcategories.split("&")){
            this.subcategories = subcategories.split("&");
          }
        } else if(this.subcategories != undefined && this.subcategories != null && this.subcategories.length > 0) {
          subcategories = this.subcategories.join("&");
        }
        if(this.tab != undefined && this.tab.subcategories == undefined){
          this.getSubCategories(this.id_tab);
        }
      } else {
        this.layout = 0;
      }
      this.getBanners();
      if(this.id_tab != undefined){
        this.actionProdutos(subcategories);
      }
    },
    actionProdutos(subcategories){
      this.getProdutos({ "type": this.name, "parametros": "0/"+this.order+"/"+ this.id_tab + (subcategories != undefined ? '/'+subcategories : ''), "filter_price": null }).then(function(){
        this.isLoading = false;
        this.loadingProdutos = true;
        this.paginacao = 1;
      }.bind(this));
    },
    scroll(){
      window.addEventListener('scroll', this.updateFeedScroll);
    },
    selectSubcat(){
      if(this.subcategories != undefined && this.subcategories != null && this.subcategories.length > 0){
        let subcategories = this.subcategories.join("&");
        this.actionProdutos(subcategories);
      } else if (this.id_tab != undefined){
        this.actionProdutos();
      }
    },
    updateFeedScroll: function() {
      let bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) > (document.documentElement.offsetHeight - 2400);
      if (bottomOfWindow && document.documentElement.scrollTop > 0) {
        if(this.loadingProdutos && !this.isLoading){
          this.isLoading = true;
          this.getProdutos({ "type": this.name, "parametros": this.paginacao+"/"+this.order+"/"+ this.id_tab + (this.subcategories != undefined && this.subcategories != null && this.subcategories.length > 0 ? '/'+this.subcategories.join("&") : ''), "filter_price": null }).then(function(response){
            if(!response){
              this.loadingProdutos = false;
            }
            this.paginacao += 1;
            this.isLoading = false;
          }.bind(this));
        }
      }
    },
    filterPrice(){
      let subcategories = undefined;
      if(this.subcategories != undefined && this.subcategories != null && this.subcategories.length > 0){
        subcategories = this.subcategories.join("&");
      }
      this.actionProdutos(subcategories);
    }
  },
  mounted() {
    this.name = this.$route['name'] == 'feed2' ? 'feed': this.$route['name'];
    this.setConfig().then(function(retorno){
      if(retorno){
        this.order = this.name != 'feed' ? 4 : 0;
        this.scroll();
        this.Nav();
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name } );
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  },
  unmounted(){
    window.removeEventListener('scroll', this.updateFeedScroll);
  }
}
</script>